import { Box } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'
import { ScheduleContributorsPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { MissingFeatureEmptyState } from 'modules/project_management/components/upsells/MissingFeatureEmptyState'
import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'
import ContributorsSchedule from 'modules/project_management/pages/ScheduleContributorsPage/ContributorsSchedule'

const ScheduleContributorsPage = () => {
  const { data: page, loading, error } = useQuery(ScheduleContributorsPageDocument)

  const canManageSchedules = !!page?.projectManagement._policies?.pagesSeeScheduleContributors.can
  const canSeeContributorsUpsell =
    !!page?.projectManagement._policies?.pagesSeeScheduleContributorsUpsell.can
  const canSeePage = canSeeContributorsUpsell || canManageSchedules

  return (
    <ResponsivePage.Body
      variant={canSeeContributorsUpsell ? 'wide' : 'fullscreen'}
      loading={loading}
      error={error}
      authorized={canSeePage}
    >
      {canSeeContributorsUpsell ? (
        <Box alignItems="center" justifyContent="center" style={{ height: '50vh' }}>
          <MissingFeatureEmptyState
            featureRequested={Features.projects_contributors}
            requestSource={ProjectsUpsellRequestSources.scheduleEmptyState}
            description={i18n.t('project_management.upselling.schedule')}
          />
        </Box>
      ) : (
        <ContributorsSchedule />
      )}
    </ResponsivePage.Body>
  )
}

export default ScheduleContributorsPage
